/*
 Created by CHT 2019/8/28 11:55
 */

class RyFormItem {
  constructor() {
    this.next = null
    this.prev = null
    this.parent = null
    this.firstChild = null
    this.lastChild = null
  }

  get children() {
    let current = this.firstChild
    let list = []
    while (current) {
      list.push(current)
      current = current.next
    }
    return list
  }
}

/**
 * @param ele
 * @return {boolean}
 */
RyFormItem.prototype.after = function (ele) {
  if (ele === this) {
    return false
  }
  ele.remove(false)
  ele.next = this.next
  ele.prev = this
  ele.parent = this.parent
  if (this.next) this.next.prev = ele
  if (this.parent && this.parent.lastChild === this) {
    this.parent.lastChild = ele
  }
  this.next = ele
  this.revised('after')
  return true
}

/**
 * @param ele
 * @return {boolean}
 */
RyFormItem.prototype.before = function (ele) {
  if (ele === this) {
    return false
  }
  ele.remove(false)
  ele.prev = this.prev
  ele.next = this
  ele.parent = this.parent
  if (this.prev) this.prev.next = ele
  if (this.parent && this.parent.firstChild === this) {
    this.parent.firstChild = ele
  }
  this.prev = ele
  this.revised('before')
  return true
}

/**
 * @param bol
 * @return {RyFormItem}
 */
RyFormItem.prototype.remove = function (bol = true) {

  if (this.next) {
    this.next.prev = this.prev
  }
  if (this.prev) {
    this.prev.next = this.next
  }
  if (this.parent && this.parent.firstChild === this) {
    this.parent.firstChild = this.next
  }
  if (this.parent && this.parent.lastChild === this) {
    this.parent.lastChild = this.prev
  }

  this.next = null
  this.prev = null

  if (bol) {
    this.revised('remove')
  }

  this.parent = null

  return this
}

/**
 * @param ele
 * @return {*}
 */
RyFormItem.prototype.appendChild = function (ele) {
  ele.parent = this
  if (this.children.length) {
    this.lastChild.after(ele)
  } else {
    this.firstChild = ele
    this.lastChild = ele
  }
  this.revised('appendChild')
}

/**
 * @param ele
 * @return {*}
 */
RyFormItem.prototype.beforeChild = function (ele) {
  ele.parent = this
  if (this.children.length) {
    this.firstChild.before(ele)
  } else {
    this.firstChild = ele
    this.lastChild = ele
  }
  this.revised('beforeChild')
}

/**
 *  向上传递发生的变化详细
 * @param ev
 */
RyFormItem.prototype.transmit = function (ev) {
  ev.path.unshift(this)
  if (this.parent) {
    this.parent.transmit(ev)
  }
}

/**
 * 当前发生修改时调用
 * @param type
 */
RyFormItem.prototype.revised = function (type) {
  const ev = {
    type,
    target: this,
    path: [this]
  }
  if (this.parent && this.parent.transmit) {
    this.parent.transmit(ev)
  }
}

export default RyFormItem
